module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"siteId":"187","matomoUrl":"https://stats.goeast.ch/","siteUrl":"https://www.pflegeheim-bruggen.ch"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
